'use client';
import React from 'react';
import NavBar from './NavBar';
import Footer from './Footer';
import ToolHeader from '@/components/common/ToolHeader';
import ControlPanel from '@/components/common/ControlPanel';

interface MethodPageLayoutProps {
    icon: React.ReactNode;
    iconColor: string;
    title: string;
    description: string;
    category: string;
    controls: React.ReactNode;
    onReset: () => void;
    children: React.ReactNode;
}

export default function MethodPageLayout({
    icon,
    iconColor,
    title,
    description,
    category,
    controls,
    onReset,
    children,
}: MethodPageLayoutProps) {
    return (
        <div className="flex min-h-screen flex-col">
            <NavBar />

            <ToolHeader
                icon={icon}
                iconColor={iconColor}
                title={title}
                description={description}
                category={category}
            />

            {/* Canvas + controls: stacked on mobile/tablet, side-by-side on desktop */}
            <main className="flex flex-1 flex-col lg:flex-row">
                <section className="flex min-w-0 flex-1 flex-col items-center justify-center bg-page p-6 lg:min-h-[400px]">
                    {children}
                </section>

                <aside className="flex w-full shrink-0 flex-col border-t-[0.5px] border-line bg-white p-[18px] lg:w-[280px] lg:border-t-0 lg:border-l-[0.5px]">
                    <ControlPanel onReset={onReset}>{controls}</ControlPanel>
                </aside>
            </main>

            <Footer />
        </div>
    );
}
